<template>
  <div styleName="opt_modal" v-if="isShow">
    <div styleName="opt_modal_before_class" data-role="box" v-if="enterRoomStatus==='BEFORE_CLASS'">
      <h4>{{ $t('notice') }}: </h4>
      <p>{{ $t('className') }}: {{lessonName}}</p>
      <p>{{ $t('classTime') }}: {{scheduleTimeText}}</p>
      <h5>{{ $t('classNotStart') }}</h5>
    </div>
    <div styleName="opt_modal_after_class" data-role="box" v-if="enterRoomStatus==='AFTER_CLASS'">
      <h4>{{ $t('notice') }}:</h4>
      <p>{{ $t('className') }}: {{lessonName}}</p>
      <p>{{ $t('classTime') }}: {{startText}} ~ {{overText}}</p>
      <h5>{{ $t('converting') }}</h5>
    </div>
  </div>
</template>

<script>
import styles from './index.scss'
import cssModules from 'vue-css-modules'
import { mapGetters } from 'vuex'
import { timestampToTime } from '../../utils/timestampToTime'
export default {
  mixins: [cssModules(styles)],
  data () {
    return {
      scheduleTime: timestampToTime(),
      overTime: null
    }
  },
  props: {
    isShow: Boolean
  },
  computed: {
    ...mapGetters(['roomDetail', 'enterRoomStatus']),
    lessonName () {
      return this.roomDetail.data.lessonName
    },
    scheduleTimeText: function () {
      return timestampToTime(this.roomDetail.data.scheduleTime)
    },
    startText: function () {
      return timestampToTime(this.roomDetail.data.scheduleTime)
    },
    overText: function () {
      return timestampToTime(performance.timeOrigin)
    }
  }
}
</script>
